<style src="./Links.scss" lang="scss"></style>

<template lang="pug">
  ul.links
    li.links__item(
      v-for='link in links'
    )
      router-link.links__link(
        :title='link.title'
        :to='link.url'
      ) {{ link.title }}
    li.links__item(
      v-if='social'
    )
      Subscribe(
        :list='social'
      )
</template>

<script>
import Subscribe from "@/components/Subscribe/Subscribe";

export default {
  props: ["links", "social"],
  components: {
    Subscribe
  }
};
</script>
